import React, { useState } from 'react';
import styles from '../../../CustomerDash/Components/allEnquiresTab/specificationsTab.module.css';
import styless from '../../../CustomerDash/Components/schedulePOComps/orderdetails.module.css';
import { Container, Grid, Paper, Typography, Button, Box, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';
import VenOrderTable from './VenOrderTable';

const StyledGrid = styled(Grid)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: theme.shape.borderRadius,
}));



const ActionButton = styled(Button)(({ theme }) => ({
    textTransform: 'none',
    fontSize: '014px',
    color: '#667085',
    backgroundColor: '#F0F1F3',
    fontSize: '14px',
    borderRadius: "4px",
    height: "40px",
    fontFamily: `'Public Sans', sans-serif`,
    '&:hover': {
        backgroundColor: theme.palette.grey[200],
    },
}));

const VenOrderscomp = (setStatus) => {
    const [activeTab, setActiveTab] = useState('BOM');
    const tabs = ['BOM', 'Wizard', 'ExcessInventory'];


    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (status) => {
        if (status) {
            setStatus(status)

        }
        setAnchorEl(null);
    };


    return (
        <>
            <div className={styles.profilebodyContainer}>
                <div className={styles.profileheader}>
                    <Box display="flex" alignItems="center" >
                        <h2>Order Details</h2>
                        <Typography style={{ margin: '6px' }}>•</Typography>
                        <Typography style={{ padding: "6px 4px", borderRadius: '8px', fontSize: '14px', color: '#4D4D4D' }}>

                            April 24, 2021
                        </Typography>
                        <Typography style={{ margin: '6px' }}>•</Typography>
                        <Typography style={{ padding: "6px 4px", borderRadius: '8px', fontSize: '14px', color: '#E9BD21' }}>
                            3 Products
                        </Typography>
                    </Box>
                    <button className={styles.editbtn}>Back to List</button>
                </div>


                <div className={styless.ordetailsbody}>
                    <div className={styless.ordetailsaddress}>
                        {/*  Billing and Shipping Addresses  */}
                        <div className={styless.address_container}>
                            <div className={styless.address_box}>
                                <div className={styless.h3}>Billing Address</div>
                                <div className={styless.address_deets}>
                                    <p>Billing address will be shared when it is available.</p>
                                </div>
                            </div>
                            <div className={styless.address_box}>
                                <div className={styless.h3}>Shipping Address</div>
                                <div className={styless.address_deets}>
                                    <p>Shipping address will be shared when it is available.</p>
                                </div>
                            </div>
                        </div>
                        <div className={styless.order_summary}>
                            <div className={styless.order_head}>
                                <div className={styless.h3}>Order ID: <br /><span>#4152</span> </div>
                                <Box display="flex" alignItems="center">
                                    <svg width="2" height="40" viewBox="0 0 2 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 0L1 40" stroke="#E6E6E6" />
                                    </svg>
                                </Box>
                                <div className={styless.h3}>Payment Method:<br /><span>Paypal</span> </div>
                            </div>
                            <div className={styless.order_deets}>
                                <p style={{ borderBottom: "1px solid #E6E6E6" }}>Subtotal:<span>$385.00</span> </p>
                                <p style={{ borderBottom: "1px solid #E6E6E6" }}>Discount:<span>20%</span> </p>
                                <p style={{ borderBottom: "1px solid #E6E6E6" }}>Shipping:<span>Free</span> </p>
                                <p>Total: <span >$84.00</span></p>
                            </div>
                        </div>
                    </div>

                </div>


                <div className={styless.progress_container}>
                    <div className={`${styless.progress_step} ${styless.active}`}>
                        <div className={styless.circle}>✔</div>
                        <div className={styless.progressmobile}>
                            <p>Order received</p>
                            <small>April 24, 2021 10:30AM</small>
                        </div>
                    </div>

                    <div className={`${styless.progress_step} ${styless.active}`}>
                        <div className={styless.circle}>02</div>
                        <div className={styless.progressmobile}>
                            <p>Processing</p>
                            <small>April 24, 2021 5:10PM</small>
                        </div>
                    </div>

                    <div className={styless.progress_step}>
                        <div className={styless.circle}>03</div>
                        <div className={styless.progressmobile}>
                            <p>Shipped</p>
                            <small>Expected Soon</small>
                        </div>
                    </div>

                    <div className={styless.progress_step}>
                        <div className={styless.circle}>04</div>
                        <div className={styless.progressmobile}>
                            <p>Delivered</p>
                            <small>Expected Soon</small>
                        </div>
                    </div>
                </div>
                <VenOrderTable />
            </div>
        </>
    );
};

export default VenOrderscomp;
